import FileDownloadIcon from "@mui/icons-material/FileDownload";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import { Link } from "@tanstack/react-router";

import FileReaderComponent from "./FileReaderComponent";
import { getDocumentUrl } from "../api/documents";

interface ViewerIconButtonProps {
  documentId?: string;
  handleClick?: () => void;
  haveError?: boolean;
}

interface TempDocument {
  url: string;
  "file-name": string;
  "Content-Type": string;
}

function ViewerIconButton({
  documentId,
  handleClick,
  haveError,
}: ViewerIconButtonProps) {
  const [openPreview, setOpenPreview] = useState(false);
  const [documentViewer, setDocumentViewer] = useState<TempDocument>({
    url: "",
    "file-name": "",
    "Content-Type": "",
  });
  const fetchDocument = async (value: string) => {
    const document = await getDocumentUrl(value);
    setDocumentViewer(document.data);
  };

  useEffect(() => {
    if (!documentId) return;
    void fetchDocument(documentId);
  }, [documentId]);

  return (
    <>
      {documentId && documentViewer.url !== "" ? (
        documentViewer["Content-Type"] === "application/pdf" ||
        documentViewer["Content-Type"].includes("image/") ? (
          <IconButton
            onClick={() => {
              setOpenPreview(true);
              handleClick && handleClick();
            }}
            size="small"
            title="View"
            sx={{ color: haveError ? "#CD3E3B" : "rgba(0, 0, 0, 0.54)" }}
          >
            <VisibilityIcon fontSize="small" />
          </IconButton>
        ) : (
          <Link
            download
            onClick={(handleClick && handleClick) || undefined}
            target="_blank"
            to={documentViewer.url}
          >
            <FileDownloadIcon
              fontSize="small"
              sx={{ color: haveError ? "#CD3E3B" : "rgba(0, 0, 0, 0.54)" }}
            />
          </Link>
        )
      ) : null}
      <FileReaderComponent
        fileName={documentViewer["file-name"]}
        fileUrl={documentViewer.url}
        handleClose={() => {
          setOpenPreview(false);
        }}
        open={openPreview}
        type={documentViewer["Content-Type"]}
      />
    </>
  );
}

export default ViewerIconButton;
